import React from "react";

/**
 * The loading and empty rows every list table repeats.
 *
 * Both were duplicated in each of the ~24 list pages, with the icon and the
 * wording as the only real differences. They are grouped here alongside
 * `ErrorRow`, which already existed, so the three states of a table look the
 * same wherever you land.
 *
 * Neither carries `data-label`, so under the stacked mobile treatment they fall
 * through as plain full-width panels rather than sprouting a column name.
 */
export const LoadingRow: React.FC<{ colSpan: number; label?: string }> = ({
  colSpan,
  label = "Loading…",
}) => (
  <tr>
    <td
      colSpan={colSpan}
      className="px-4 py-10 text-center text-sm text-gray-400"
    >
      {label}
    </td>
  </tr>
);

export const EmptyRow: React.FC<{
  colSpan: number;
  label: string;
  /** A lucide icon, sized by the caller-independent wrapper below. */
  icon?: React.ElementType;
}> = ({ colSpan, label, icon: Icon }) => (
  <tr>
    <td colSpan={colSpan} className="px-4 py-16 text-center">
      {Icon ? (
        <div className="w-14 h-14 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
          <Icon className="size-6 text-gray-400" />
        </div>
      ) : null}
      <p className="text-sm text-gray-500">{label}</p>
    </td>
  </tr>
);
